module.exports = __webpack_public_path__ + "img/2014-10_bloomberg.4e848d41.png";